import { Calendar, Plus, Trash2 } from "lucide-react";
import { formatMDY } from "@utils/ptoHelpers";

export function BlockedDaysSection({
  blockedDays,
  newBlocked,
  setNewBlocked,
  onAddBlocked,
  onDeleteBlocked,
  inModal = false,
}: {
  blockedDays: any[];
  newBlocked: { date: string; part: string; reason: string };
  setNewBlocked: React.Dispatch<React.SetStateAction<{ date: string; part: string; reason: string }>>;
  onAddBlocked: () => void;
  onDeleteBlocked: (id: number) => void;
  inModal?: boolean;
}) {
  return (
    <div className={inModal ? "" : "mt-8"}>
      {!inModal && (
        <h2 className="tw-text-xl tw-font-semibold tw-mb-3 tw-flex tw-items-center tw-gap-2">
          <Calendar size={18} /> Block Days
        </h2>
      )}
      <div className="tw-bg-white dark:tw-bg-[#0D1117] tw-rounded-lg tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-p-4">
        <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-3 md:tw-items-end">
          <div className="tw-flex tw-flex-col">
            <label className="tw-text-xs tw-text-gray-600 tw-mb-1">Date</label>
            <input
              type="date"
              className="tw-border tw-rounded tw-px-2 tw-py-1 tw-bg-white dark:tw-bg-[#111827]"
              value={newBlocked.date}
              onChange={(e) =>
                setNewBlocked((s) => ({ ...s, date: e.target.value }))
              }
            />
          </div>
          <div className="tw-flex tw-flex-col">
            <label className="tw-text-xs tw-text-gray-600 tw-mb-1">Part</label>
            <select
              className="tw-border tw-rounded tw-px-2 tw-py-1 tw-bg-white dark:tw-bg-[#111827]"
              value={newBlocked.part}
              onChange={(e) =>
                setNewBlocked((s) => ({ ...s, part: e.target.value }))
              }
            >
              <option value="FULL">FULL</option>
              <option value="AM">AM</option>
              <option value="PM">PM</option>
            </select>
          </div>
          <div className="tw-flex-1 tw-flex tw-flex-col">
            <label className="tw-text-xs tw-text-gray-600 tw-mb-1">
              Reason (optional)
            </label>
            <input
              type="text"
              className="tw-border tw-rounded tw-px-2 tw-py-1 tw-bg-white dark:tw-bg-[#111827] tw-w-full"
              placeholder="Holiday, blackout, etc."
              value={newBlocked.reason}
              onChange={(e) =>
                setNewBlocked((s) => ({ ...s, reason: e.target.value }))
              }
            />
          </div>
          <button
            className="tw-inline-flex tw-items-center tw-gap-1 tw-bg-[#38C5B0] hover:tw-bg-[#32B5A1] tw-text-white tw-rounded tw-px-3 tw-py-2"
            onClick={onAddBlocked}
          >
            <Plus size={16} /> Add Block
          </button>
        </div>

        <div className="tw-mt-4 tw-overflow-auto">
          <table className="tw-min-w-full tw-text-sm">
            <thead className="tw-bg-gray-50 dark:tw-bg-[#0A1E2D]">
              <tr>
                <th className="tw-text-left tw-px-4 tw-py-2">Date</th>
                <th className="tw-text-left tw-px-4 tw-py-2">Part</th>
                <th className="tw-text-left tw-px-4 tw-py-2">Reason</th>
                <th className="tw-text-left tw-px-4 tw-py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {blockedDays.map((b) => (
                <tr
                  key={b.id}
                  className="tw-border-t tw-border-gray-100 dark:tw-border-gray-800"
                >
                  <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap">
                    {formatMDY(b.date)}
                  </td>
                  <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap">{b.part}</td>
                  <td
                    className="tw-px-4 tw-py-2 tw-max-w-[400px] tw-truncate"
                    title={b.reason || ""}
                  >
                    {b.reason || ""}
                  </td>
                  <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap">
                    <button
                      className="tw-inline-flex tw-items-center tw-gap-1 tw-text-red-700 tw-bg-red-50 hover:tw-bg-red-100 tw-border tw-border-red-200 tw-rounded tw-px-2 tw-py-1"
                      onClick={() => onDeleteBlocked(b.id)}
                    >
                      <Trash2 size={16} /> Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {blockedDays.length === 0 && (
            <div className="tw-p-3 tw-text-gray-500">No blocked days yet.</div>
          )}
        </div>

        <div className="tw-mt-3 tw-text-xs tw-text-gray-500">
          Note: Blocking FULL also blocks AM/PM for that date. PTO creation will
          reject any selection that hits a blocked date/part or overlaps an
          approved/pending request.
        </div>
      </div>
    </div>
  );
}
